<template>
  <div
    class="grid mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-5 lg:grid-cols-4"
  >
    <div
      @click="redirectRental()"
      class="rounded-lg overflow-hidden shadow-2xl relative"
    >
      <img
        class="w-full h-full opacity-10 object-cover"
        src="https://homesby360.s3.amazonaws.com/Bios/windows.jpg"
        alt="window home"
      />
      <div class="px-6 py-4 absolute left-0 top-0">
        <div class="flex-1">
          <a class="block">
            <p class="uppercase text-2xl font-semibold text-gray-900">
              Find a Rental
            </p>

            <ul
              style="list-style-type:disc; line-height: 2em;"
              class="mt-3 text-base text-gray-700"
            >
              <li>
                Online Application and Payments
              </li>
              <li>
                High Quality Properties
              </li>
              <li>
                Quick Maintenance Handling
              </li>
            </ul>
          </a>
        </div>
      </div>
    </div>

    <div
      @click="isManagement()"
      class="rounded-lg overflow-hidden shadow-2xl relative"
    >
      <img
        class="w-full h-full opacity-10 object-cover"
        src="https://homesby360.s3.amazonaws.com/Bios/windows.jpg"
        alt="window home"
      />
      <div class="px-6 py-4 absolute left-0 top-0">
        <div class="flex-1">
          <a class="block">
            <p class="uppercase text-2xl font-semibold text-gray-900">
              Property Management
            </p>
            <ul
              style="list-style-type:disc;line-height: 2em;"
              class="mt-3 text-bold text-gray-500"
            >
              <li>
                Access to exclusive digital platforms.
              </li>
              <li>
                360 performs routine inspections to keep your home in tip-top
                shape.
              </li>
              <li>
                Renter screening services include eviction and background
                checks.
              </li>
            </ul>
          </a>
        </div>
      </div>
    </div>

    <div
      @click="isBuyer()"
      class="rounded-lg overflow-hidden shadow-2xl relative"
    >
      <img
        class="w-full h-full opacity-10 object-cover"
        src="https://homesby360.s3.amazonaws.com/Bios/windows.jpg"
        alt="window home"
      />
      <div class="px-6 py-4 absolute left-0 top-0">
        <div class="flex-1">
          <a class="block">
            <p class="uppercase text-2xl font-semibold text-gray-900">
              Buy a Home
            </p>
            <ul
              style="list-style-type:disc; line-height: 2em;"
              class="mt-3 text-base text-gray-500"
            >
              <li>
                Local area EXPERTS able to get you the best deal!
              </li>
              <li>
                Professional negotiations and contract services
              </li>
              <li>
                Well versed with various loan types - including VA loans!
              </li>
            </ul>
          </a>
        </div>
      </div>
    </div>

    <!-- @click="buyHome()" -->

    <div
      @click="isSeller()"
      class="rounded-lg overflow-hidden shadow-2xl relative"
    >
      <img
        class="w-full h-full opacity-10 object-cover"
        src="https://homesby360.s3.amazonaws.com/Bios/windows.jpg"
        alt="window home"
      />
      <div class="px-6 py-4 absolute left-0 top-0">
        <div class="flex-1">
          <a class="block">
            <p class="uppercase text-2xl font-semibold text-gray-900">
              Buy a Home
            </p>
            <ul
              style="list-style-type:disc; line-height: 2em;"
              class="mt-3 text-base text-gray-500"
            >
              <li>
                Local area EXPERTS able to get you the best deal!
              </li>
              <li>
                Professional negotiations and contract services
              </li>
              <li>
                Well versed with various loan types - including VA loans!
              </li>
            </ul>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["userAuth"],
  methods: {
    redirectRental() {
      this.$router.push({ name: "rentals", params: { value: "true" } });
    },

    isManagement() {
      if (this.userAuth) {
        this.$router.push({ name: "listings" });
      } else {
        this.$router.push({
          name: "ManageRegister",
          params: { state: "Management" }
        });
      }
    },

    isSeller() {
      if (this.userAuth) {
        this.$router.push({ name: "listings" });
      } else {
        this.$router.push({
          name: "listingRegister",
          params: { state: "Seller" }
        });
      }
    },

    isBuyer() {
      if (this.userAuth) {
        this.$router.push({ name: "listings" });
      } else {
        this.$router.push({
          name: "BuyerRegister",
          params: { state: "Buyer" }
        });
      }
    }
  }
};
</script>
<style>
.pattern-bg {
  background-image: url("https://www.maxibienes.com/images/patterns/pattern1.jpg");
  width: 100%;
  height: 200%;
  background-repeat: repeat;
  background-position: center center;
  text-align: center;
  overflow: hidden;
  position: relative;
}

.parallax {
  padding: 100px 0 85px 0px;
  border-top: 1px solid #e3e3e3;
  border-bottom: 1px solid #e3e3e3;
  position: relative;
}
</style>
